//
// Helper functions
// --------------------------------------------------


/**
 * Debounce functions for better performance
 * ES Module-ified & modified from original debounce (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Function} fn The function to debounce
 */
export function debounce(fn) {
  // Setup an animation frame "timer"
  var timeout;

  // Return a function to run debounced
  return function () {

    // Setup the arguments
    var context = this;
    var args = arguments;

    // If there's a timer, cancel it
    if (timeout) {
      window.cancelAnimationFrame(timeout);
    }

    // Setup the new requestAnimationFrame()
    timeout = window.requestAnimationFrame(function () {
      fn.apply(context, args);
    });
  }
}



// Return sibling elements in the DOM
// ---------------------------------------
export function getSiblings(element) {
  // Setup siblings array and get the first sibling
  var siblings = [];
  var sibling = element.parentNode.firstChild;

  // Loop through each sibling and push to the array
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== element) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }

  return siblings;
}



// Return previous sibling elements in the DOM
// ---------------------------------------
export function getPreviousSiblings(el, selector) {
  var prevSibs = [];

  while (el = el.previousElementSibling) {
    if(!selector || el.matches(selector)) {
      prevSibs.push(el);
    }
  }

  if (prevSibs.length === 0) {
    prevSibs = null;
  }

  return prevSibs;
}



// Add Script Once
// ---------------------------------------
export function addScriptOnce(src, id, async = true) {
  if(uniqueAddScriptOnceUrls[src]){
    return;
  }

  var script = document.createElement('script');
  var insertElem = document.getElementsByTagName('script')[0];

  script.src = src;
  script.async = (async) ? true : false;
  script.id = id;

  uniqueAddScriptOnceUrls[src] = true;
  insertElem.parentNode.insertBefore(script, insertElem);
}
